import style from '../style.module.scss';

const EmptySidebarState = () => {
    return (
        <div className={style.emptySidebarState}>
            <h3 className={style.emptySidebarTitle}>Nu sunt stații disponibile în această zonă</h3>
            <p className={style.emptySidebarText}>
                Încearcă o locație apropiată sau modifică filtrele pentru a vedea mai multe rezultate.
            </p>
        </div>
    );
};

export default EmptySidebarState;
